import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-4 right-4 left-4 md:left-auto md:w-96 z-[100] animate-in slide-in-from-bottom-4 fade-in duration-500">
            <div className="glass-strong p-5 relative overflow-hidden">
                {/* Decorative background glow */}
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-violet-500/10 rounded-full blur-3xl" />
                <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-fuchsia-500/10 rounded-full blur-3xl" />

                <div className="relative">
                    <div className="flex items-start gap-3 mb-3">
                        <div className="p-2 bg-violet-500/10 dark:bg-violet-400/10 rounded-lg">
                            <svg className="w-5 h-5 text-violet-600 dark:text-violet-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                            </svg>
                        </div>
                        <div>
                            <h3 className="font-semibold text-slate-900 dark:text-white text-sm">We use cookies</h3>
                            <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 leading-relaxed">
                                We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
                                <Link to="/cookies" className="ml-1 text-violet-600 dark:text-violet-400 hover:underline">
                                    Learn more
                                </Link>
                            </p>
                        </div>
                    </div>

                    <div className="flex gap-3 mt-4">
                        <button
                            onClick={handleAccept}
                            className="flex-1 btn-primary py-2 text-xs"
                        >
                            Accept All
                        </button>
                        <button
                            onClick={handleAccept} // For now, we'll treat closing as accepting/dismissing to avoid complexity, or just dismiss
                            className="flex-1 btn-ghost py-2 text-xs"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
